export default __webpack_public_path__ + "static/media/queso.85eaaf42.jpeg";